export const translation = (text: string, translationArr: string[], textArr: string[]) => {
    const index = textArr.findIndex((element) => element === text)
    return translationArr[index]
}